<template>
  <div>
    <h4>
      <span v-if="checkoutConditions.allow_photo_attachment">
        {{ $t('message.booking.checkout_step.customer_area_photos') }}
      </span>
      <span v-if="!checkoutConditions.allow_photo_attachment && checkoutConditions.allow_remark">
        {{ $t('message.booking.checkout_step.additional_remark') }}
      </span>
    </h4>
    <div class="card shadow-sm">
      <div class="card-body">
        <div class="mb-3" v-if="checkoutConditions.allow_photo_attachment">
          <i class="fal fa-image"></i> 
          <label>
            {{ checkoutConditions.required_photo_attachment ? $t('message.booking.checkout_step.attach_photos') : $t('message.booking.checkout_step.attach_photos_not_required') }}
          </label>
          <span class="text-danger" v-if="checkoutConditions.required_photo_attachment">*</span> 
          <div class="text-remark mb-2">
            {{ ($i18n.locale === 'th') ? checkoutConditions.photo_attachment_remark_th : checkoutConditions.photo_attachment_remark_en }}
          </div>
          <vue-dropzone ref="vueDropzone"
                        id="dropzone"
                        class="dropzone-dashed"
                        :destroyDropzone="false"
                        :options="dropzoneOptions"
                        @vdropzone-sending="vueDropZoneAddParams"
                        @vdropzone-removed-file="vueDropZoneRemovedFile"
                        @vdropzone-mounted="vueDropZoneMounted"
                        @vdropzone-success="vueDropZoneSuccess" />
          <div class="mt-2 text-remark -status-alert" v-if="errors.has('photoAttachment')">
            <i class="fas fa-exclamation-triangle"></i> {{ $t('message.required_photo_attachment') }}
          </div>
        </div>

        <!-- Remark -->
        <div class="form-group">
          <label for="remark">{{ $t('message.service_request.big_cleaning_remark') }}</label>
          <textarea rows="3"
                    ref="remark"
                    id="remark"
                    :placeholder="$t('message.service_request.deep_cleaning_remark')"
                    class="form-control textarea-jumbo"
                    v-model="customerAreaRemark"></textarea>
        </div>
        <div class="text-small text-orange pb-2" v-if="checkoutConditions.service_remark_title_th">
          {{ ($i18n.locale === 'th') ? checkoutConditions.service_remark_title_th : checkoutConditions.service_remark_title_en }}
        </div>
        <div class="text-remark" v-if="checkoutConditions.service_remark_detail_th"
             v-html="($i18n.locale === 'th') ? checkoutConditions.service_remark_detail_th : checkoutConditions.service_remark_detail_th">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import vue2Dropzone from 'vue2-dropzone'
  import axios from 'axios'

  export default {
    inject: ['$validator'],
    props: {
      checkoutConditions: Object
    },
    components: {
      vueDropzone: vue2Dropzone
    },
    data () {
      return {
        dropzoneOptions: {
          acceptedFiles: 'image/*',
          url: 'https://beneat.co',
          thumbnailMethod: 'crop',
          thumbnailWidth: 160,
          thumbnailHeight: 160,
          maxFilesize: 5,
          dictDefaultMessage: `<i class="fal fa-cloud-upload"></i> ${this.$i18n.t('message.button.upload_photos')}`,
          headers: { 'Content-Type': 'multipart/form-data' },
          addRemoveLinks: true,
          autoProcessQueue: true,
          maxFiles: 20
        },
        customerAreaRemark: null,
        count: 0
      }
    },
    computed: {
      ...mapGetters({
        authState: 'auth/getState',
        user: 'auth/getUser'
      }),
      ...mapState('booking', ['customerAreaPhotos', 'preCheckoutData'])
    },
    watch: {
      customerAreaRemark () {
        this.$emit('setAdditionalRemark', this.customerAreaRemark)
      },
      customerAreaPhotos () {
        if (this.customerAreaPhotos.length) {
          this.$validator.errors.remove('photoAttachment')
        }
      }
    },
    methods: {
      vueDropZoneAddParams (file, xhr, formData) {
        this.count += 1
        formData.append('count', this.count)
        formData.append('user_id', this.user.id)
      },
      vueDropZoneMounted () {
        const uploadUrl = `${this.$http.options.root}/bookings/add-customer-area-photos`
        this.$refs.vueDropzone.options.url = uploadUrl
        this.$refs.vueDropzone.setOption('url', uploadUrl)
        const headers = { 'Authorization': `Bearer ${this.authState.token}` }
        this.$refs.vueDropzone.options.headers = headers
        this.$refs.vueDropzone.setOption('headers', headers)
      },
      vueDropZoneSuccess (file, response) {
        if (!response.error) {
          const imageUrl = response.image_url
          file.image_url = imageUrl
          this.$store.commit('booking/ADD_CUSTOMER_AREA_PHOTO', imageUrl)
        }
      },
      async vueDropZoneRemovedFile (file, error, xhr) {
        const url = '/bookings/delete-customer-area-photos'
        const imageUrl = file.image_url
        const { data } = await axios.post(url, { image_url: imageUrl })
        if (!data.error) {
          this.$store.commit('booking/DELETE_CUSTOMER_AREA_PHOTO', imageUrl)
        }
      }
    },
    mounted () {
      const action = this.$route.query.action
      if (action && action === 'checkout_payment') {
        if (this.customerAreaPhotos.length) {
          for (let imageUrl of this.customerAreaPhotos) {
            var file = { size: 500, name: 'customer_area_photo', type: 'image/jpeg' }
            this.$refs.vueDropzone.manuallyAddFile(file, imageUrl)
          }
        }
      } else {
        // Clear customer area photos
        this.$store.commit('booking/CLEAR_CUSTOMER_AREA_PHOTOS')
      }
    }
  }
</script>

<style lang="scss">
.dropzone {
  .dz-preview {
    .dz-image {
      img {
        object-fit: cover !important;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/booking/components/CustomerAreaPhoto.vue